// extracted by mini-css-extract-plugin
export var headerCell = "_14-1";
export var loadingSpinnerContainer = "_14-4";
export var loadingStateCell = "_14-5";
export var rowWrapper = "_14-3";
export var standaloneTable = "_14-6";
export var table = "_14-0";
export var white = "_14-2";